<template>
  <a-modal
    title="请输入验证码"
    :maskClosable="false"
    :width="250"
    :closable="true"
    :footer="null"
    :visible="visible"
    @cancel="visible = false"
  >
    <div style="text-align: center">
      <j-graphic-code
        style="display: block"
        @success="generateCode"
        ref="jgraphicCodeRef"
      ></j-graphic-code>
      <a-input
        style="display: block; width: 136px; margin: auto;"
        placeholder="验证码"
        v-model="verifiedCodeInput"
      ></a-input>
      <br />
      <a-button
        style="display: inline-block; width: 80px"
        @click="handleVerify"
        type="primary"
        >继续</a-button
      >
    </div>
  </a-modal>
</template>

<script>
import JGraphicCode from "@/components/jeecg/JGraphicCode";
export default {
  name: "VerifyCodeModal",
  components: {
    JGraphicCode,
  },
  data() {
    return {
      visible: false,
      verifiedCode: "",
      verifiedCodeInput: "",
      verifiedOk: false,
      callback: null,
    };
  },
  methods: {
    show(callback) {
      this.visible = true;
      this.callback = callback;
      this.reload();
    },
    generateCode(value) {
      this.verifiedCode = value.toLowerCase();
    },
    handleVerify() {
      if (this.verifiedCode == this.verifiedCodeInput) {
        this.verifiedOk = true;
        if (this.callback) {
          this.callback();
        }
        this.visible = false;
      } else {
        this.$message.error("验证码错误");
        this.reload();
      }
    },
    reload() {
      this.$nextTick(() => {
        this.$refs.jgraphicCodeRef.reloadPic();
        this.verifiedCodeInput = "";
      });
    },
  },
};
</script>

<style>
</style>